import { Loader } from '../utils/loader'
import { SERVICES } from '../config/constants'

class FormLoader extends Loader {}

export const formLoader = new FormLoader({
  service: SERVICES.form
})
